import { render, staticRenderFns } from "./ComplexForm.vue?vue&type=template&id=011af754&scoped=true&"
import script from "./ComplexForm.vue?vue&type=script&lang=js&"
export * from "./ComplexForm.vue?vue&type=script&lang=js&"
import style0 from "./ComplexForm.vue?vue&type=style&index=0&id=011af754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011af754",
  null
  
)

export default component.exports